import { styled } from 'styled-components';
import { IconButton } from '@mui/material';
import { Icon } from '@mdi/react';
import { mdiCheckCircle, mdiCheckCircleOutline } from '@mdi/js';
import { useTranslation } from 'react-i18next';

interface IProps {
    checked?: boolean;
    className?: string;
    isHidden?: boolean;
    onClick?(e: React.MouseEvent<HTMLButtonElement>): void;
}

const BaseDevelopmentItemCheck = ({ className, checked, onClick }: IProps) => {
    const [translate] = useTranslation();

    return (
        <IconButton
            aria-label={translate(checked ? 'uncheck' : 'check')}
            className={`${className} ${checked && 'checked'}`}
            component="span"
            size="large"
            tabIndex={!!onClick ? 0 : -1}
            onClick={onClick}
        >
            <Icon
                path={checked ? mdiCheckCircle : mdiCheckCircleOutline}
                size="2.4rem"
            />
        </IconButton>
    );
};

export const DevelopmentItemCheck = styled(BaseDevelopmentItemCheck)`
    padding: 0;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'initial')};
    margin-right: ${({ theme }) => theme.spacing(2)};

    &:hover {
        background: none;
    }

    color: ${({ theme }) => theme.vars.palette.grey[300]};

    &.checked {
        color: ${({ theme }) => theme.vars.palette.primary.main};
    }
`;
